<template src="./TerminalParcels/TerminalParcels.html"></template>
<script>
export default {
    name: 'TerminalParcels',
    props: {
        parcels: Array,
    },
}
</script>
<style lang="scss" scoped>
.root {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 10px;
}

.parcel-order-link {
    text-decoration: underline;
}
</style>
